const KelasParalelSearch = {
    idKelas: null,
    namaKelasParalel: null,
    idSekolah: null,
    idKelasParalel: null
};

export default KelasParalelSearch;